import React, { Component } from 'react'
import { Button, Input } from 'loyal-react'

class PhoneEmpty extends Component {
  state = {
    firstStep: true,
    secondStep: false,
    thirdStep: false,
    isValid: undefined,
    dataError: '',
    disableButton: true
  }

  verifyNow = () => {
    this.setState({
      firstStep: false,
      secondStep: true,
      thirdStep: false
    })
  }

  verifyPhone = () => {
    this.setState({
      firstStep: false,
      secondStep: false,
      thirdStep: true,
      isValid: true,
      dataError: ''
    })
  }

  typeCode = () => {
    let codeVerification = document.getElementById('codeVerification').value
    if (codeVerification.length > 0) {
      this.setState({
        disableButton: false
      })
    } else {
      this.setState({
        disableButton: true
      })
    }
  }

  codeVerification = () => {
    window.alert('ok')
  }

  render () {
    return (
      <div className='col-12 row mx-0 px-0'>
        <div className={`col-12 px-0 pb-2 ${this.state.firstStep ? '' : 'd-none'}`}>
          <p className='txt-body-sm txt-bold  title-color'>Você ainda não possui nenhum celular verificado.</p>
          <p className='txt-body-sm mt-1'>Realizar essa verificação é muito importante para que seus resgates no Catálogo de Prêmios ocorram de forma segura.</p>
          <p className='txt-body-sm'>Assim saberemos que apenas você estará utilizando seus pontos e não um possível fraudador.</p>
          <div className='col-12 col-md-3 px-0 pt-2'>
            <Button
              className='btn btn-sm btn-featured txt-button txt-center txt-font-body-bold'
              text='VERIFIQUE AGORA'
              onClick={() => this.verifyNow()}
            />
          </div>
        </div>
        <div className={`col-12 px-0 pb-2 row mx-0 ${this.state.secondStep ? '' : 'd-none'}`}>
          <p className='col-12 mx-0 px-0 txt-body-sm txt-bold color-brand-1'>Precisaremos do seu número de celular</p>
          <p className='col-12 mx-0 px-0 txt-body-sm mt-1'>Tenha um celular em mãos para que possamos enviar um código para a validação do número.</p>
          <Input
            id='phoneNumber'
            className='col-12 col-md-3 mt-2 pl-md-0 pr-md-1 px-0'
            labelClass='l-1 pl-half'
            label='Celular'
            mask={['+', /\d/, /\d/, '(', /\d/, /\d/, ')', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
            valid={this.state.isValid}
            data-error={this.state.dataError}
          />
          <Button
            className='col-12 col-md-3 mt-2 btn btn-sm btn-featured btn-cart btn-icon txt-button txt-center txt-font-body-bold'
            text='receber sms'
            iconName='icon_message'
            onClick={() => this.verifyPhone()}
          />
          <Button
            className='col-12 col-md-3 mt-2 ml-0 ml-md-1 btn btn-sm btn-featured btn-cart btn-icon txt-button txt-center txt-font-body-bold'
            text='receber ligação'
            iconName='icon_call'
            onClick={() => this.verifyPhone()}
          />
        </div>
        <div className={`col-12 px-0 pb-2 row mx-0 ${this.state.thirdStep ? '' : 'd-none'}`}>
          <p className='col-12 mx-0 px-0 txt-body-sm mt-1'>Aguarde alguns segundos para receber o código no número: <strong>(1*) 96***-4068</strong></p>
          <Input
            id='codeVerification'
            className='col-12 col-md-3 mt-2 pl-md-0 pr-md-1 px-0'
            labelClass='l-1 pl-half'
            label='Código de verificação'
            onChange={() => this.typeCode()}
          />
          <Button
            className='col-12 col-md-3 mt-2 btn btn-sm btn-featured txt-button txt-center txt-font-body-bold'
            text='VERIFICAR'
            disabled={this.state.disableButton}
            onClick={() => this.codeVerification()}
          />
        </div>
      </div>
    )
  }
}

export default PhoneEmpty



// WEBPACK FOOTER //
// ./src/Participant/TwoStepVerification/PhoneEmpty/PhoneEmpty.js